var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#030512",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9021 18.655L21.1246 14.0108C21.6131 13.5733 21.6131 12.8329 21.1246 12.4291L21.0495 12.3281C20.5235 11.8906 19.7345 11.8906 19.246 12.3281L15.9021 15.3233C15.4137 15.7608 14.5871 15.7608 14.1362 15.3233L10.7547 12.3281C10.2663 11.8906 9.43968 11.8906 8.95124 12.3281L8.8761 12.3954C8.38766 12.8329 8.38766 13.5733 8.8761 14.0108L14.0986 18.6887C14.5871 19.0925 15.4137 19.0925 15.9021 18.655Z",
    fill: "#030512"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle);
export default __webpack_public_path__ + "static/media/arrow-down-circle.80c7d0e86d1c152cf60455e2d7404827.svg";
export { ForwardRef as ReactComponent };